import { render } from "./SurveyStage.vue?vue&type=template&id=10ec7158&scoped=true"
import script from "./SurveyStage.vue?vue&type=script&lang=js"
export * from "./SurveyStage.vue?vue&type=script&lang=js"

import "./SurveyStage.vue?vue&type=style&index=0&id=10ec7158&scoped=true&lang=css"

import exportComponent from "/home/d6338/zsurvey-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ec7158"]])

export default __exports__